import './common/extensions/type-extensions';
import './common/extensions/string-extensions';
import './common/extensions/array-extensions';

import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './website/pages/home/home.component';
import {HeaderComponent} from './website/template/header/header.component';
import {FooterComponent} from './website/template/footer/footer.component';
import {AboutComponent} from './website/pages/about/about.component';
import {NotFoundComponent} from './website/pages/not-found/not-found.component';
import {TermsAndConditionsComponent} from './website/pages/terms-and-conditions/terms-and-conditions.component';
import {PrivacyPolicyComponent} from './website/pages/privacy-policy/privacy-policy.component';
import {MasterComponent} from './website/template/master/master.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms';
import {MerchantComponent} from './website/pages/merchant/merchant.component';
import {LoginComponent} from './website/pages/login/login.component';
import {MatCardModule} from "@angular/material/card";
import {JwtInterceptor} from "./common/interceptors/jwt.interceptor";
import {MerchantHomeComponent} from './merchant/pages/merchant-home/merchant-home.component';
import {MerchantLoginComponent} from './merchant/pages/merchant-login/merchant-login.component';
import {MerchantSignupComponent} from './merchant/pages/merchant-signup/merchant-signup.component';
import {SignupFormComponent} from './merchant/components/signup-form/signup-form.component';
import {FileUploadComponent} from './common/components/file-upload/file-upload.component';
import {DragAndDropDirective} from './common/directives/drag-and-drop.directive';
import {AngularFireStorageModule} from "@angular/fire/compat/storage";
import {AngularFireModule} from "@angular/fire/compat";
import {environment} from "../environments/environment";
import {DisableFormDirective} from './common/directives/disable-form.directive';
import {DisableFormComponent} from './common/directives/disable-form/disable-form.component';
import {SubscribeEmailComponent} from './website/components/subscribe-email/subscribe-email.component';
import {ConfirmEmailComponent} from './website/pages/confirm-email/confirm-email.component';
import {
  MerchantMoreInfoComponent
} from './merchant/pages/merchant-signup/merchant-more-info/merchant-more-info.component';
import {
  MerchantContactInfoComponent
} from './merchant/pages/merchant-signup/merchant-contact-info/merchant-contact-info.component';
import {
  MerchantReviewingAccountComponent
} from './merchant/pages/merchant-signup/merchant-reviewing-account/merchant-reviewing-account.component';
import {
  MerchantEmailConfirmationComponent
} from './merchant/pages/merchant-signup/merchant-email-confirmation/merchant-email-confirmation.component';
import {
  MerchantBasicInfoComponent
} from './merchant/pages/merchant-signup/merchant-basic-info/merchant-basic-info.component';
import {
  MerchantLoginComponent as MerchantLoginDuringSignupComponent
} from "./merchant/pages/merchant-signup/merchant-login/merchant-login.component";
import {SecondsToMinutesSecondsPipe} from "./common/pipes/SecondsToMinutesSecondsPipe";
import {LanguageInterceptor} from "./common/interceptors/language.interceptor";
import {
  AboutUsComponent,
  AboutUsComponent as MerchantAboutUsComponent
} from './merchant/pages/merchant-home/about-us/about-us.component';
import {
  HowItWorksItemComponent
} from './merchant/pages/merchant-home/how-it-works/how-it-works-item/how-it-works-item.component';
import {HowItWorksComponent} from './merchant/pages/merchant-home/how-it-works/how-it-works.component';

import {FaqsComponent} from './merchant/pages/merchant-home/faqs/faqs.component';
import {FaqsComponent as WebsiteFaqs} from './website/pages/faqs/faqs.component';
import {
  EnhanceServicesComponent
} from './merchant/pages/merchant-home/enhance-services/enhance-services.component';
import {
  EnhanceServiceItemComponent
} from './merchant/pages/merchant-home/enhance-service-item/enhance-service-item.component';
import {BenefitsComponent} from './merchant/pages/merchant-home/benefits/benefits.component';
import {CommunityComponent} from './merchant/pages/merchant-home/community/community.component';
import {HeroSectionComponent} from './merchant/pages/merchant-home/hero-section/hero-section.component';
import {JoinUsComponent} from './merchant/pages/merchant-home/join-us/join-us.component';
import {FeaturedChefItemComponent} from './website/components/featured-chef-item/featured-chef-item.component';
import {FeaturedDishComponent} from './website/components/featured-dish/featured-dish.component';
import {CustomSearchBarComponent} from './website/components/custom-search-bar/custom-search-bar.component';
import {StayConnectedComponent} from "./website/pages/home/stay-connected/stay-connected.component";
import {CustomerAboutUsComponent} from "./website/pages/home/customer-about-us/customer-about-us.component";
import {FeaturedChefsComponent} from "./website/pages/home/featured-chefs/featured-chefs.component";
import {MealsComponent} from "./website/pages/home/meals/meals.component";
import {PopularDishesComponent} from "./website/pages/home/popular-dishes/popular-dishes.component";
import {ChooseUsComponent} from "./website/pages/home/choose-us/choose-us.component";
import {DiscoverUsComponent} from "./website/pages/home/discover-us/discover-us.component";
import {MerchantHomeTabComponent} from './website/pages/merchant/merchant-home-tab/merchant-home-tab.component';
import {MatTabsModule} from "@angular/material/tabs";
import {ProductItemComponent} from './website/components/product-item/product-item.component';
import {MerchantMenuTabComponent} from './website/pages/merchant/merchant-menu-tab/merchant-menu-tab.component';
import {
  MerchantImagesAndVideosTabComponent
} from './website/pages/merchant/merchant-images-and-videos-tab/merchant-images-and-videos-tab.component';
import {MerchantListPageComponent} from './website/pages/merchant-list-page/merchant-list-page.component';
import {MerchantListItemComponent} from './website/components/merchant-list-item/merchant-list-item.component';
import {ProductDetailsComponent} from "./website/pages/product-details/product-details.component";
import {ProductsCarouselComponent} from "./website/components/products-carousel/products-carousel.component";
import {FormsModule} from '@angular/forms';
import {MatSliderModule} from "@angular/material/slider";
import {CheckBoxComponent} from "./common/components/input/check-box/check-box.component";
import {MobileNumberComponent} from "./common/components/input/mobile-number/mobile-number.component";
import {DropDownListComponent} from "./common/components/input/drop-down-list/drop-down-list.component";
import {InputPictureComponent} from "./common/components/input/input-picture/input-picture.component";
import {InputTextFieldComponent} from "./common/components/input/input-text-field/input-text-field.component";
import {TextAreaComponent} from "./common/components/input/text-area/text-area.component";
import {NumericOnlyDirective} from "./common/components/input/directive/numeric-only.directive";
import {PrimaryButtonComponent} from "./common/components/button/primary-button/primary-button.component";
import {
  MerchantListFiltersModalComponent
} from './website/pages/merchant-list-page/merchant-list-filters-modal/merchant-list-filters-modal.component';


import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatDialogModule} from "@angular/material/dialog";
import { MerchantReviewTabComponent } from './website/pages/merchant/merchant-review-tab/merchant-review-tab.component';
import { MerchantLocationTabComponent } from './website/pages/merchant/merchant-location-tab/merchant-location-tab.component';
import { ClaimBusinessDialogComponent } from './website/pages/merchant/claim-business-dialog/claim-business-dialog.component';
import { ClaimBusinessSubmittedDialogComponent } from './website/pages/merchant/claim-business-submitted-dialog/claim-business-submitted-dialog.component';
import { ContactUsComponent } from './website/pages/contact-us/contact-us.component';
import {AngularFireAuthModule} from "@angular/fire/compat/auth";
import {
  MerchantForgetPasswordComponent
} from "./merchant/pages/merchant-forget-password/merchant-forget-password.component";
import { SecondaryButtonComponent } from "./common/components/button/secondary-button/secondary-button.component";
import {
  MerchantEmailConfirmationPasswordComponent
} from "./merchant/pages/merchant-email-confirmation-password/merchant-email-confirmation-password.component";
import {
  MerchantCreateNewPasswordComponent
} from "./merchant/pages/merchant-create-new-password/merchant-create-new-password.component";
import {
  MerchantResendEmailConfirmationPasswordComponent
} from "./merchant/pages/merchant-resend-email-confirmation/merchant-resend-email-confirmation-password.component";
import { CookiesPolicyComponent } from './website/pages/cookies-policy/cookies-policy.component';
import { WriteReviewDialogComponent } from './website/pages/merchant/merchant-review-tab/write-review-dialog/write-review-dialog.component';
import { ReviewSubmittedDialogComponent } from './website/pages/merchant/merchant-review-tab/review-submitted-dialog/review-submitted-dialog.component';
import { SignUpComponent } from './website/pages/sign-up/sign-up.component';
import { CustomerBasicInfoComponent } from './website/pages/sign-up/customer-basic-info/customer-basic-info.component';
import { CustomerEmailVerificationComponent } from './website/pages/sign-up/customer-email-verification/customer-email-verification.component';
import { CustomerForgetPasswordComponent } from './website/pages/sign-up/customer-forget-password/customer-forget-password.component';
import { CustomerProfileComponent } from './website/pages/customer-profile/customer-profile.component';
import { ChangeInfoDialogComponent } from './website/pages/customer-profile/change-info-dialog/change-info-dialog.component';
import { ListMenuComponent } from './website/pages/merchant/merchant-menu-tab/list-menu/list-menu.component';
import { LoginAlertComponent } from "./website/components/login-alert/login-alert.component";



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    NotFoundComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    MasterComponent,
    MerchantComponent,
    LoginComponent,
    MerchantHomeComponent,
    MerchantLoginComponent,
    MerchantSignupComponent,
    SignupFormComponent,
    FileUploadComponent,
    DragAndDropDirective,
    DisableFormDirective,
    DisableFormComponent,
    SubscribeEmailComponent,
    ConfirmEmailComponent,
    MerchantMoreInfoComponent,
    MerchantContactInfoComponent,
    MerchantReviewingAccountComponent,
    MerchantEmailConfirmationComponent,
    MerchantBasicInfoComponent,
    MerchantLoginDuringSignupComponent,
    SecondsToMinutesSecondsPipe,
    MerchantAboutUsComponent,
    HowItWorksItemComponent,
    HowItWorksComponent,
    FaqsComponent,
    EnhanceServicesComponent,
    EnhanceServiceItemComponent,
    BenefitsComponent,
    CommunityComponent,
    HeroSectionComponent,
    JoinUsComponent,
    StayConnectedComponent,
    AboutUsComponent,
    CustomerAboutUsComponent,
    FeaturedChefsComponent,
    FeaturedChefItemComponent,
    MealsComponent,
    PopularDishesComponent,
    FeaturedDishComponent,
    ChooseUsComponent,
    DiscoverUsComponent,
    CustomSearchBarComponent,
    MerchantHomeTabComponent,
    MerchantReviewTabComponent,
    ProductItemComponent,
    MerchantMenuTabComponent,
    MerchantImagesAndVideosTabComponent,
    MerchantListPageComponent,
    MerchantListItemComponent,
    ProductDetailsComponent,
    ProductsCarouselComponent,
    CheckBoxComponent,
    MobileNumberComponent,
    DropDownListComponent,
    InputPictureComponent,
    InputTextFieldComponent,
    TextAreaComponent,
    NumericOnlyDirective,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    MerchantListFiltersModalComponent,
    MerchantReviewTabComponent,
    MerchantLocationTabComponent,
    ClaimBusinessDialogComponent,
    ClaimBusinessSubmittedDialogComponent,
    ContactUsComponent,
    MerchantForgetPasswordComponent,
    MerchantEmailConfirmationPasswordComponent,
    MerchantCreateNewPasswordComponent,
    MerchantResendEmailConfirmationPasswordComponent,
    WebsiteFaqs,
    CookiesPolicyComponent,
    WriteReviewDialogComponent,
    ReviewSubmittedDialogComponent,
    SignUpComponent,
    CustomerBasicInfoComponent,
    CustomerEmailVerificationComponent,
    CustomerForgetPasswordComponent,
    CustomerProfileComponent,
    ChangeInfoDialogComponent,
    ListMenuComponent,
    LoginAlertComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatCardModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    MatTabsModule,
    FormsModule,
    MatSliderModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    // {provide: MatBottomSheetRef, useValue: {}},
    // {provide: MAT_BOTTOM_SHEET_DATA, useValue: {}},
    // {provide: MatBottomSheet, useValue: {}},
    // {provide: MatBottomSheetModule, useValue: {}}
    // {
    //   provide: FIREBASE_OPTIONS,
    //   useValue: environment.production
    // }
  ],
  bootstrap: [AppComponent],
  exports: [
    MatBottomSheetModule,
    MatDialogModule
  ]
})
export class AppModule {
}
